var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeToHire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_time_to_hire",
    "data-name": "icona time to hire",
    transform: "translate(-12 -82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_time_to_hire-2",
    "data-name": "icona time to hire",
    transform: "translate(-1529.633 -537.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_41",
    "data-name": "Ellisse 41",
    transform: "translate(1542.976 622.778)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.411,
    cy: 8.411,
    r: 8.411,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.411,
    cy: 8.411,
    r: 8.011,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_302",
    "data-name": "Tracciato 302",
    transform: "translate(1544.845 624.647)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.542,0A6.542,6.542,0,1,1,0,6.542,6.542,6.542,0,0,1,6.542,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.542059421539307 0.5999994277954102 C 3.265599250793457 0.5999994277954102 0.5999994277954102 3.265599250793457 0.5999994277954102 6.542059421539307 C 0.5999994277954102 9.818519592285156 3.265599250793457 12.4841194152832 6.542059421539307 12.4841194152832 C 9.818519592285156 12.4841194152832 12.4841194152832 9.818519592285156 12.4841194152832 6.542059421539307 C 12.4841194152832 3.265599250793457 9.818519592285156 0.5999994277954102 6.542059421539307 0.5999994277954102 M 6.542059421539307 -9.5367431640625e-07 C 10.1551399230957 -9.5367431640625e-07 13.08411979675293 2.928979873657227 13.08411979675293 6.542059421539307 C 13.08411979675293 10.1551399230957 10.1551399230957 13.08411979675293 6.542059421539307 13.08411979675293 C 2.928979873657227 13.08411979675293 -9.5367431640625e-07 10.1551399230957 -9.5367431640625e-07 6.542059421539307 C -9.5367431640625e-07 2.928979873657227 2.928979873657227 -9.5367431640625e-07 6.542059421539307 -9.5367431640625e-07 Z",
    stroke: "none",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_301",
    "data-name": "Tracciato 301",
    d: "M6.382,4.833a3.724,3.724,0,0,0-1.421-.891,2.161,2.161,0,1,0-2.446,0A3.744,3.744,0,0,0,0,7.477H.584a3.154,3.154,0,0,1,6.308,0h.584A3.714,3.714,0,0,0,6.382,4.833ZM3.738,3.738A1.577,1.577,0,1,1,5.315,2.161,1.579,1.579,0,0,1,3.738,3.738Z",
    transform: "translate(1547.649 627.45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1610",
    "data-name": "Raggruppa 1610",
    transform: "translate(1549.985 619.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_194",
    "data-name": "Rettangolo 194",
    width: 0.935,
    height: 2.243,
    transform: "translate(1.402 1.308)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_195",
    "data-name": "Rettangolo 195",
    width: 1.308,
    height: 3.738,
    rx: 0.654,
    transform: "translate(0 1.308) rotate(-90)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1611",
    "data-name": "Raggruppa 1611",
    transform: "translate(1557.458 622.533) rotate(40)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_194-2",
    "data-name": "Rettangolo 194",
    width: 0.935,
    height: 1.121,
    transform: "translate(1.402 1.308)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_195-2",
    "data-name": "Rettangolo 195",
    width: 1.308,
    height: 3.738,
    rx: 0.654,
    transform: "translate(0 1.308) rotate(-90)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1613",
    "data-name": "Raggruppa 1613",
    transform: "translate(1547.059 624.394) rotate(140)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_194-3",
    "data-name": "Rettangolo 194",
    width: 0.934,
    height: 1.121,
    transform: "translate(1.402 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_195-3",
    "data-name": "Rettangolo 195",
    width: 1.309,
    height: 3.739,
    rx: 0.654,
    transform: "translate(3.739 1.121) rotate(90)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_788",
    "data-name": "Rettangolo 788",
    transform: "translate(12 82)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.2,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    width: 19.8,
    height: 19.8,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeToHire);
export default __webpack_public_path__ + "static/media/time_to_hire.2827119fe77c7fcd30119a14c5bd53ca.svg";
export { ForwardRef as ReactComponent };